// extracted by mini-css-extract-plugin
export default {"departments":"yD-z","departmentHeading":"zD-z","departmentSection":"AD-z","departmentName":"BD-z","departmentLink":"CD-z","expandIcon":"DD-z"};